export function formatNumber (value: number, minimumFractionDigits = 0, maximumFractionDigits = minimumFractionDigits) {
  const decimalFormat = new Intl.NumberFormat('de-DE', {
    style: 'decimal',
    minimumFractionDigits,
    maximumFractionDigits
  })
  return decimalFormat.format(value)
}
